import React, { useState } from 'react'
import { RiContactsBook3Line } from 'react-icons/ri'
import { FaCheckDouble } from 'react-icons/fa'
import { Formik, Form } from 'formik'

import { DeleteIcon, EditIcon } from '../../../utils/TableActionIcons'
import CardHeading from '../../../shared/CardHeading'
import CustomButton from '../../../shared/CustomButton'
import {
  emergencyContactColumns,
  emergencyContactTypes
} from '../../../constants/BeneficiaryConstants'
import CustomTable from '../../../shared/CustomTable'
import TextInput from '../../../shared/TextInput'
import DropdownField from '../../../shared/DropdownField'
import { emergencyContactsValidationSchema } from '../../../validations/BeneficiaryFormValidations'
import { useTranslation } from 'react-i18next'
import CheckPermission from '../../../hooks/CheckPermission'
const ReusableModal = React.lazy(() => import('../../../shared/ReuseableModal'))

const BeneficiaryEmergencyContact = ({
  formValues,
  formikRef,
  setOpenCreateContactModal,
  openCreateContactModal
}) => {
  const { hasPermission } = CheckPermission()
  const [selectedContactData, setSelectedContactData] = useState(null)
  const { t } = useTranslation()
  const actionsCoumn = {
    body: actionsTemplate,
    header: t('Actions'),
    headerCellClass: '!bg-gray-200'
  }
  const columnsData = [...emergencyContactColumns(t), actionsCoumn]

  function actionsTemplate (rowData, column) {
    return (
      <div className='flex items-center gap-1'>
        {hasPermission('patient', 'update') && <EditIcon
          size={17}
          className='text-gray-500 mx-2 cursor-pointer'
          onClick={() => handleEditContact(rowData, column)}
        />}
        {hasPermission('patient', 'delete') && <DeleteIcon
          size={17}
          className='text-red-500 cursor-pointer'
          onClick={() => handleDeleteContact(rowData, column)}
        />}
      </div>
    )
  }

  // Handle Delete contact
  const handleDeleteContact = (rowData, column) => {
    let index = column?.rowIndex
    const updatedContactsData = [
      ...formikRef?.current?.values?.emergency_contacts
    ]
    updatedContactsData.splice(index, 1)
    formikRef?.current?.setFieldValue('emergency_contacts', updatedContactsData)
  }

  //Handle Edit contact
  const handleEditContact = (rowData, column) => {
    let index = column?.rowIndex
    const contactData = formValues?.emergency_contacts[index]
    if (contactData) {
      contactData.index = index
      setSelectedContactData(contactData)
      setOpenCreateContactModal(true)
    }
  }

  const handleOpenCreateContactModal = () => {
    setOpenCreateContactModal(true)
  }

  return (
    <div className='mb-4'>
      <div className='flex items-center justify-between mt-2 mb-2'>
        <CardHeading
          title={t('EmergencyContact')}
          Icon={RiContactsBook3Line}
          iconSize={20}
        />
      </div>
      <div className='w-full mt-4 md:mt-6'>
        <CustomTable
          columns={columnsData}
          data={formValues?.emergency_contacts}
        />
      </div>
      <ReusableModal
        isVisible={openCreateContactModal}
        position='top'
        title={
          selectedContactData
            ? t('UpdateContactDetails')
            : t('AddContactDetails')
        }
        HeaderIcon={RiContactsBook3Line}
        onClose={() => {
          setOpenCreateContactModal(false)
          setSelectedContactData(null)
        }}
      >
        <EmergencyContactFields
          formikRef={formikRef}
          setOpenCreateContactModal={setOpenCreateContactModal}
          selectedContactData={selectedContactData}
          setSelectedContactData={setSelectedContactData}
        />
      </ReusableModal>
    </div>
  )
}

const EmergencyContactFields = ({
  formikRef,
  setOpenCreateContactModal,
  selectedContactData,
  setSelectedContactData
}) => {
  const { t } = useTranslation()
  const initialValues = {
    type: selectedContactData?.type || '',
    first_name: selectedContactData?.first_name || '',
    last_name: selectedContactData?.last_name || '',
    phone_number: selectedContactData?.phone_number || '',
    relationship: selectedContactData?.relationship || '',
    comments: selectedContactData?.comments || ''
  }

  const handleFormSubmit = values => {
    if (selectedContactData) {
      const updatedContacts =
        formikRef?.current?.values?.emergency_contacts.map((contact, index) =>
          index == selectedContactData?.index ? { ...values } : contact
        )
      formikRef?.current?.setFieldValue('emergency_contacts', updatedContacts)
    } else {
      formikRef?.current?.setFieldValue('emergency_contacts', [
        ...(formikRef?.current?.values?.emergency_contacts || []),
        values
      ])
    }
    setOpenCreateContactModal(false)
    if (setSelectedContactData) {
      setSelectedContactData(null)
    }
  }

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={emergencyContactsValidationSchema(t)}
        onSubmit={handleFormSubmit}
      >
        <Form>
          <div className='grid grid-cols-2  lg:grid-cols-3 gap-x-3 gap-y-1 mt-3'>
            <DropdownField
              label={t('Type')}
              options={emergencyContactTypes}
              placeholder={t('Selecttype')}
              name='type'
            />
            <TextInput
              label={t('FirstName*')}
              placeholder={t('Enterfirstname')}
              name='first_name'
            />
            <TextInput
              label={t('LastName*')}
              placeholder={t('Enterlastname')}
              name='last_name'
            />
            <TextInput
              label={t('PhoneNumber')}
              placeholder={t('Enterphonenumber')}
              name='phone_number'
            />
            <TextInput
              label={t('Relationship*')}
              placeholder={t('Enterrelationship')}
              name='relationship'
            />
            <TextInput
              label={t('Comments')}
              placeholder={t('Entercomments')}
              name='comments'
            />
          </div>
          <div className='flex items-center justify-end mt-3'>
            <CustomButton
              icon={<FaCheckDouble size={12} className='me-2' />}
              type='submit'
              label={
                selectedContactData ? t('UpdateContact') : t('AddNewContact')
              }
              buttonType='primary'
            />
          </div>
        </Form>
      </Formik>
    </div>
  )
}

export default BeneficiaryEmergencyContact
